import { combineReducers } from 'redux';
import { authenReducer } from './authen/reducer';
import { alertReducer } from './alert/reducer';
import { authenLineReducer } from './line/reducer';
import { infoReducer } from './info/reducer';
import { titleReducer } from './title/reducer';
import { headerReducer } from './header/reducer';
import registerProductReducer from './registerProduct/reducer';
import warrantyDataReducer from './warrantydata/reducer';

const rootReducer = combineReducers({
  authen: authenReducer,
  alert: alertReducer,
  line: authenLineReducer,
  info: infoReducer,
  title: titleReducer,
  header: headerReducer,
  registerProduct: registerProductReducer,
  warrantyData: warrantyDataReducer,
});

export default rootReducer;
